import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  // GET_USER_SHARE_MEMBERSHIP,
  GET_USER_SHARED_PAGES_CONTENT,
  SHARED_DASHBOARD_DATA,
} from "helper/url_helper";
import { axiosAccount } from "services/api";
import {
  MEMBERSHIP_DATA,
  MEMBERSHIP_DATA_LOADING,
  TEAM_DATA,
  TEAM_DATA_LOADING,
} from "./actionTypes";

export const FetchTeamData = () => {
  return async dispatch => {
    try {
      dispatch({ type: TEAM_DATA_LOADING, payload: true });
      const res = await axiosAccount.get(SHARED_DASHBOARD_DATA);
      if (!!res) {
        dispatch({
          type: TEAM_DATA,
          payload: res?.data?.data?.sharedMemberships,
        });
      }
      dispatch({ type: TEAM_DATA_LOADING, payload: false });
    } catch (err) {
      dispatch({ type: TEAM_DATA_LOADING, payload: false });
      errorTostHandler(err, 75);
    }
  };
};

export const FetchMemberShip = payload => {
  return async dispatch => {
    try {
      dispatch({ type: MEMBERSHIP_DATA_LOADING, payload: true });
      const res = await axiosAccount.post(
        GET_USER_SHARED_PAGES_CONTENT,
        payload
      );
      if (!!res) {
        dispatch({
          type: MEMBERSHIP_DATA,
          payload: res.data.data?.categories,
        });
      }
      dispatch({ type: MEMBERSHIP_DATA_LOADING, payload: false });
    } catch (err) {
      dispatch({ type: MEMBERSHIP_DATA_LOADING, payload: false });
      errorTostHandler(err, 76);
    }
  };
};
